import { Snackbar } from "components";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "components/app/dialog/dialog";
import ImageUrl from "components/app/image-url/ImageUrl";
import SearchBar from "components/app/search-bar/SearchBar";

import { ScrollArea, ScrollBar } from "components/ui/scroll-area";
import { Loader, Minus, Plus, X } from "lucide-react";

import { useRef, useState } from "react";

import { useLocation } from "react-router-dom";
import { AppLog } from "services";
import { useAppSelector } from "store/store";
import { RequestApi, RouteApi, StatusMsg } from "utils";
interface DialogProps {
  onUploadSuccess: (response: any) => void;
  isDailogAddLineManager: boolean;
  setisDailogAddLineManager: (value: boolean) => void;
  setShiftGroupId: any;
  editEmloyeeId: any;
  setShopEmployeeDetail: any;
  ShopEmployeeDetail: any;
  itemEmployeeManager: any;
  setItemEmployeeManager: any;
  setSearchTextInput: any;
}
export default function DailogAdddLineManagerStaff({
  onUploadSuccess,
  isDailogAddLineManager,
  setisDailogAddLineManager,
  editEmloyeeId,
  setShopEmployeeDetail,
  itemEmployeeManager,
  setSearchTextInput,
  setItemEmployeeManager,
}: // updateImage, // Add this prop to pass the updated image back to the parent component
DialogProps) {
  const { token } = useAppSelector((state) => state.auth);
  const [loadingSubmitUpdateShopEmployeeManager, setLoadingSubmitUpdateShopEmployeeManager] = useState<boolean>(false);
  const [loadingSubmitDeleteShopEmployeeManager, setLoadingSubmitDeleteShopEmployeeManager] = useState<boolean>(false);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const shopId = searchParams.get("id");
  const [idRecommendedDelete, setIdRecommendedDelete] = useState(null);
  const [idRecommendedUpdate, setIdRecommendedUpdate] = useState(null);

  const submitUpdateShopEmployeeManager = async (id: any) => {
    setLoadingSubmitUpdateShopEmployeeManager(true);
    try {
      let url: string = "";
      url = RouteApi.submitUpdateShopEmployeeManager;
      url += `token=${token}`;
      const pyaload = {
        shop_id: shopId,
        employee_id: editEmloyeeId,
        manager_employee_id: id,
      };
      const response = await RequestApi(url, { data: pyaload });
      if (response.status === "success") {
        onUploadSuccess(response);
        setLoadingSubmitUpdateShopEmployeeManager(false);
        if (response.user_shop_employee_man) {
          setShopEmployeeDetail((prevItemGroups: any) => {
            const recommended = Array.isArray(prevItemGroups.managers) ? prevItemGroups.managers : [];
            return {
              ...prevItemGroups,
              managers: [...recommended, response.user_shop_employee_man],
            };
          });
        } else {
          setLoadingSubmitUpdateShopEmployeeManager(false);
        }
        setisDailogAddLineManager(false);
      } else {
        setLoadingSubmitUpdateShopEmployeeManager(false);
        Snackbar({
          message: response.msg,
          status: StatusMsg.warning,
        });
      }
    } catch (error) {
      setLoadingSubmitUpdateShopEmployeeManager(false);
      AppLog.show({
        message: `[submitUpdateShopEmployeeManager]`,
        status: StatusMsg.error,
        error,
      });
    } finally {
    }
  };
  const submitDeleteShopEmployeeManager = async (id: any) => {
    setLoadingSubmitDeleteShopEmployeeManager(true);
    try {
      let url: string = "";
      url = RouteApi.submitDeleteShopEmployeeManager;
      url += `token=${token}`;
      const pyaload = {
        shop_id: shopId,
        employee_id: editEmloyeeId,
        manager_employee_id: id,
      };
      const response = await RequestApi(url, { data: pyaload });
      if (response.status === "success") {
        onUploadSuccess(response);
        setLoadingSubmitDeleteShopEmployeeManager(false);
      }
    } catch (error) {
      setLoadingSubmitDeleteShopEmployeeManager(false);

      AppLog.show({
        message: `[submitDeleteShopEmployeeManager]`,
        status: StatusMsg.error,
        error,
      });
    } finally {
    }
  };

  const [page, setPage] = useState(1); // or use scroll_tag if API uses that

  const fetchMoreData = async () => {
    setIsFetching(true);
    try {
      const url = `${RouteApi.getShopEmployeeManager}token=${token}`;
      const data = {
        shop_id: shopId,
        search_text: "",
        employee_id: editEmloyeeId,
        page: page + 1,
      };
      const response = await RequestApi(url, { data });

      if (response.status === "success") {
        setItemEmployeeManager({
          ...itemEmployeeManager,
          data: [...(itemEmployeeManager?.data || []), ...response?.user_shop_employees?.data],
        });
        setPage((prev) => prev + 1);
      }
    } catch (error) {
      AppLog.show({
        message: `[fetchMoreData]`,
        status: StatusMsg.error,
        error,
      });
    } finally {
      setIsFetching(false);
    }
  };
  const scrollTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const scrollContainerRef = useRef<HTMLDivElement | null>(null);
  const [isFetching, setIsFetching] = useState(false);

  const handleScroll = () => {
    // setHasScroll(true);
    if (scrollTimeoutRef.current) {
      clearTimeout(scrollTimeoutRef.current);
    }
    scrollTimeoutRef.current = setTimeout(() => {
      // setHasScroll(false);
    }, 500);
    const container = scrollContainerRef.current;
    if (!container || isFetching) return;

    const { scrollTop, scrollHeight, clientHeight } = container;

    if (scrollTop + clientHeight >= scrollHeight - 100) {
      fetchMoreData();
    }
  };
  return (
    <Dialog open={isDailogAddLineManager}>
      <DialogContent isShowBtnXClose={false} className="custom-dialog-class flex flex-col justify-between max-w-[1000px] h-[calc(100vh-80px)]">
        <DialogHeader>
          <DialogTitle>Direct Line Manager</DialogTitle>
          <DialogDescription>Search director line manager by name, click "+" icon button.</DialogDescription>
          <div
            className="absolute flex items-center justify-center right-4 top-1 z-40 cursor-pointer rounded-full bg-gray-200 dark:bg-accent w-[28px] h-[28px]"
            onClick={() => {
              setisDailogAddLineManager(false);
            }}
          >
            <X />
          </div>
        </DialogHeader>
        <div ref={scrollContainerRef} onScroll={handleScroll} className=" w-full gap-3 h-full overflow-y-auto">
          <div className="flex flex-col pe-3 h-full">
            <div className="sticky top-[-1px] dark:bg-[#020817] left-0 py-2 px-1 z-10  bg-white">
              <div className="flex-1">
                <div className="relative">
                  <SearchBar
                    onValueChange={(value) => {
                      setSearchTextInput(value);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="grid lg:grid-cols-5  gap-y-3 gap-x-2 mt-4 z-[1] ">
              {itemEmployeeManager?.data?.map((item: any, index: number) => {
                return (
                  <div key={index} className="relative z-1 w-full max-w-sm border rounded-lg cursor-pointer">
                    {item.is_manager === 0 ? (
                      <>
                        <label
                          className="absolute opacity-80 p-1 mx-auto z-50 top-2 right-2 text-white group bg-blue-500  font-semibold cursor-pointer rounded-full 
                                                                                                          w-8 h-8 flex items-center justify-center text-md  "
                        >
                          {loadingSubmitUpdateShopEmployeeManager === true && idRecommendedUpdate === item.employee_id ? (
                            <Loader className="animate-spin w-8 h-8" />
                          ) : (
                            <Plus
                              onClick={() => {
                                setIdRecommendedUpdate(item.employee_id);
                                submitUpdateShopEmployeeManager(item.employee_id);
                              }}
                              className="w-8 h-8"
                            />
                          )}
                        </label>
                      </>
                    ) : (
                      <label
                        className="absolute opacity-80 p-1 mx-auto z-50 top-2 right-2 text-white group bg-red-500  font-semibold cursor-pointer rounded-full 
                                                                                                          w-8 h-8 flex items-center justify-center text-md  "
                      >
                        {loadingSubmitDeleteShopEmployeeManager === true && idRecommendedDelete === item.employee_id ? (
                          <Loader className="animate-spin w-8 h-8" />
                        ) : (
                          <Minus
                            onClick={() => {
                              setIdRecommendedDelete(item.employee_id);
                              submitDeleteShopEmployeeManager(item.employee_id);
                            }}
                            className="w-8 h-8"
                          />
                        )}
                      </label>
                    )}
                    <div className=" aspect-square w-full relative overflow-hidden  ">
                      <ImageUrl className="rounded-t-md cursor-pointer object-cover w-full h-full " src={item.picture} alt="" />
                    </div>

                    <div className={`p-4  `}>
                      <h5 className="text-md font-semibold line-clamp-2 overflow-hidden h-[20px] ">{item?.local_name}</h5>
                      <span className="text-sm line-clamp-1 overflow-hidden h-[20px]  ">{item?.department}</span>

                      <p className=" font-semibold line-clamp-2 text-sm text-muted-foreground h-[20px]"> {item.position}</p>

                      <p className="font-semibold line-clamp-2 text-sm  text-muted-foreground h-[20px]">
                        {/* {item.joined_date} */}
                        {(() => {
                          const date = new Date(item.joined_date);
                          const day = date.getDate();
                          const weekday = date.toLocaleDateString("en-GB", {
                            weekday: "short",
                          });
                          const month = date.toLocaleDateString("en-GB", {
                            month: "short",
                          });

                          const year = date.getFullYear();
                          return `${month}, ${day}-${weekday}-${year}`;
                        })()}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          {/* <ScrollBar orientation="vertical" /> */}
        </div>
        <DialogFooter></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
